import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { RetirementState } from "@reducers/types/HRM/retirement-state";

import {
  createRetirementRequest,
  getRetirementRequest,
} from "@actions/HRM/retirement/retirement-actions";
import { getRetirementState } from "@selectors/HRM/retirement/retirement-selector";

import { useAppSelector } from "@helpers/redux";
import { RetirementType } from "@type/HRM/retirement";

interface UseRetirement {
  retirement: RetirementType;
  createRetirementHandler: (event: RetirementType) => void;
  getRetirementRequestOngoing: boolean;
  getRetirementSuccess: boolean;
  getRetirementFailed: boolean;
  createRetirementRequestOngoing: boolean;
  createRetirementSuccess: boolean;
  createRetirementFailed: boolean;
}

export const useRetirement = (
  retirementID?: string | number
): UseRetirement => {
  const dispatch = useDispatch();

  const {
    data,
    getRetirementRequestOngoing,
    getRetirementSuccess,
    getRetirementFailed,
    createRetirementRequestOngoing,
    createRetirementSuccess,
    createRetirementFailed,
  } = useAppSelector<RetirementState>(getRetirementState);

  useEffect(() => {
    if (retirementID) {
      dispatch(getRetirementRequest(retirementID));
    }
  }, [dispatch]);

  const retirement = data as RetirementType;

  const createRetirementHandler = (data: RetirementType) => {
    dispatch(createRetirementRequest(data));
  };

  return {
    retirement,
    getRetirementRequestOngoing,
    getRetirementSuccess,
    getRetirementFailed,
    createRetirementRequestOngoing,
    createRetirementSuccess,
    createRetirementFailed,
    createRetirementHandler,
  };
};
